import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Header from '../components/header';
import * as HeaderAction from '../actions/headerAction';
function mapStateToProps(state) {
  return {
    org_limit: state?.Chargecard?.wallet_limit?.org_limit,
    user_limit: state?.Chargecard?.wallet_limit?.user_limit,
    userInfo: state?.Chargecard?.userInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...HeaderAction,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Header);
